import { useEffect, useState } from 'react';

// SPEC §"Pages": `/`, `/settings`, `/about`. We use hash routing so a
// vanilla static host (Cloudflare Pages on a path you didn't configure
// explicitly) doesn't 404 a deep link. The address bar will read e.g.
// `https://soluu-tester.meadowsdesign.com/#/settings`.

export type Route = '/' | '/settings' | '/about';

export const ROUTES: readonly Route[] = ['/', '/settings', '/about'];

function parse(hash: string): Route {
  const path = hash.replace(/^#/, '') || '/';
  if (path === '/settings' || path === '/about') return path;
  return '/';
}

export function useRoute(): [Route, (next: Route) => void] {
  const [route, setRoute] = useState<Route>(() =>
    typeof window === 'undefined' ? '/' : parse(window.location.hash),
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onHash = () => setRoute(parse(window.location.hash));
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  const navigate = (next: Route) => {
    if (typeof window === 'undefined') return;
    window.location.hash = next;
  };

  return [route, navigate];
}
